import '@hotmart/cosmos/dist/collapse'

import type { MutableRefObject, ReactNode } from 'react'
import { forwardRef } from 'react'

import CollapseItem from './collapseItem'
import { useShadowRef } from './hooks/useShadowRef'

export type CollapseProps = {
  label?: string | ReactNode
  collapseActions?: ReactNode
  children: ReactNode
  active?: boolean
  className?: string
}
const Collapse = forwardRef(
  ({ collapseActions, children, className, active, label = '' }: CollapseProps, ref) => {
    const { shadowRootRef } = useShadowRef(ref as MutableRefObject<HTMLElement>, active)

    const props = {
      class: className,
      ref: shadowRootRef,
      ...(active && { active })
    }

    return (
      <hot-collapse {...props}>
        {collapseActions ? collapseActions : label}
        {children}
      </hot-collapse>
    )
  }
)

const CompoundCollapse = Object.assign(Collapse, { CollapseItem })

export default CompoundCollapse
